"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./RadioButton.style"));

function RadioButton(_ref) {
  var children = _ref.children,
      value = _ref.value,
      id = _ref.id,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      imgSrc = _ref.imgSrc,
      _ref$isBlue = _ref.isBlue,
      isBlue = _ref$isBlue === void 0 ? false : _ref$isBlue;

  var _react_1$useState = react_1.useState(checked),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isChecked = _react_1$useState2[0],
      setChecked = _react_1$useState2[1];

  function handleOnChange(_ref2) {
    var target = _ref2.target;
    setChecked(target.checked);
    onChange && onChange({
      childrenText: children,
      value: value
    });
  }

  react_1.useEffect(function () {
    setChecked(checked);
  }, [checked]);
  return jsx_runtime_1.jsxs("div", Object.assign({
    css: styles.container(size, disabled, isChecked),
    className: "mrt-radio-button"
  }, {
    children: [jsx_runtime_1.jsxs("span", Object.assign({
      css: styles.outerCircle
    }, {
      children: [jsx_runtime_1.jsx("input", {
        css: styles.input,
        id: id,
        type: "radio",
        value: value,
        checked: isChecked,
        onChange: handleOnChange,
        disabled: disabled
      }, void 0), isChecked && jsx_runtime_1.jsx("span", {
        css: styles.innerCircle
      }, void 0)]
    }), void 0), jsx_runtime_1.jsxs("label", Object.assign({
      className: "mrt-radio-button-label",
      css: styles.label(isChecked && isBlue),
      htmlFor: id
    }, {
      children: [children, imgSrc && jsx_runtime_1.jsx("img", {
        src: imgSrc,
        alt: "radio content"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

exports.default = react_1.memo(RadioButton);